module.exports = __webpack_public_path__ + "static/media/SG-SNI3_1Is2b80PfDj8yzd4j0pVc7MLFMNfRO8KL.9604b939.bin";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbs/SG-SNI3_1Is2b80PfDj8yzd4j0pVc7MLFMNfRO8KL
// module id = 849
// module chunks = 0